import { defineComponent } from 'vue'

import t, { initTranslations } from '@/javascript/lib/i18next'
import { es } from '@/javascript/locales/es.json'
import CAFlex from '@ds/components/containers/CAFlex'
import CALink from '@ds/components/navigation/CALink'
import CAIcon from '@ds/components/shared/CAIcon'
import { useGlobalStore } from '@vuejs/stores/GlobalStore'

export default defineComponent({
	name: 'SimpleHeader',

	props: {
		hideLogout: { default: false, type: Boolean },
		showActivatedInsightsBrand: { default: false, type: Boolean },
	},

	computed: {
		globalStore(): ReturnType<typeof useGlobalStore> {
			return useGlobalStore()
		},
	},

	beforeMount() {
		initTranslations()
	},

	render() {
		return (
			<div class="simple-header" data-test="simple-header">
				<CAFlex
					align="center"
					class="w-full simple-header__flex-box"
					justify="between"
				>
					<div class="logo-container">
						<CALink
							href="/"
							class="logo logo--on-member-dashboard"
							data-test="careacademy-logo"
						>
							<CAIcon
								aria-label={this.showActivatedInsightsBrand
									? 'Activated Insights logo'
									: 'CareAcademy logo'}
								class="logo__image careacademy-logo"
								icon={this.showActivatedInsightsBrand ? 'SVGActivatedInsights' : 'SVGCareAcademyFull'}
							/>
						</CALink>
					</div>

					<CAFlex align="center" justify="end">
						{this.showActivatedInsightsBrand &&
							<div class="logout-container">
								<CALink
									href="https://activatedinsights.com/contact/"
									class="ca-link__default"
									data-test="need-help-link"
									target="_blank"
									text={this.globalStore.selectedLanguage === 'es'
										? es.global.needHelp
										: t('global.needHelp')}
								/>
							</div>
						}

						{!this.hideLogout &&
							<div class="logout-container">
								<a
									href="/users/sign_out"
									class="capitalize ca-link__default"
									data-method="delete"
									data-test="logout-link"
									rel="nofollow"
								>
									{this.globalStore.selectedLanguage === 'es'
										? es.global.logout
										: t('global.logout')}
								</a>
							</div>
						}
					</CAFlex>
				</CAFlex>
			</div>
		)
	},
})
